import { Element } from "react-scroll";
import Tabs from "../components/Tabs/Tabs";

export default function ProjectsSection() {
  return (
    <Element className="section section--projects" name="projects">
      <div className="section-container">
        <div className="section__head">
          <h1>Latest projects</h1>
          <p>
            A look at some of my latest work — crafted with attention to
            details.
          </p>
        </div>
        <Tabs />
      </div>
    </Element>
  );
}
